export const AudioContextClass = window.webkitAudioContext ?? window.AudioContext;
